// extracted by mini-css-extract-plugin
export var Card = "Card-module--Card---ZKxW";
export var Card_depth_0 = "Card-module--Card_depth_0--Gk40M";